export default __webpack_public_path__ + "static/sqlserver-eac62cb538a2bee5aeead13c2c06775d.png";